module.exports = __webpack_public_path__ + "f23b80c75b4671025389ce3e3e65f687.woff";